import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { config } from "../../constants";
const locale = require("react-redux-i18n").I18n;
class RegisterHeader extends Component {
  HomePage = () => {
    return config.baseUrl + '/shop/' + this.props.project.project_encrypt;
  };
  render() {
    return (
      <div className="box-order-main-a">
        <div><h3 className="ttl_page">{locale.t("dataProfile")}</h3></div>
        <div>
          <a href={this.HomePage()}>
            <button className="btn btn-cc">{locale.t("backToHome")}{" "}</button>
          </a>
          {
            this.props.mode === "View" && (
              <button
                className="btn btn-edit"
                onClick={() => this.props.onEdit("Edit")}
              >
                {locale.t("edit")}
              </button>
            )
          }
          {
            this.props.mode === "Expire" && (
              <button className="btn btn-edit-warning">
                {locale.t("editExpire")}
              </button>
            )
          }
        </div>
      </div>
    );
  }
}

RegisterHeader.propTypes = {
  status: PropTypes.string.isRequired,
  onEdit: PropTypes.func.isRequired
};

RegisterHeader.defaultProps = {
  status: "",
  onEdit: () => null
};
const mapStateToProps = state => ({
  l: state.i18n.locale,
  project: state.project.info,
});
export default connect(
  mapStateToProps,
  null
)(RegisterHeader);
